import React, {useState} from 'react'
import { Dropdown } from 'primereact/dropdown';
import Earth from "../../../assets/images/earth.svg"
import EarthBlack from "../../../assets/images/earth-black.svg"
import { useTranslation } from "react-i18next";
import LnagWrapper from "./style";
import useMediaQuery from "@mui/material/useMediaQuery";
import config from "../../../config"

const LanguageDropDown = ({color, login}) => {
    const { i18n } = useTranslation();
    const [language, setLanguage] = useState(i18n.language)

    const matches = useMediaQuery(
        `(min-width:${config.breakdowns.DESKTOP_MIN_WIDTH}px)`
      );

    return (
        <LnagWrapper className={`mx-2 d-flex gap-1 flex-row-reverse lang-container ${color ? color : "white"}`}>
            <Dropdown value={language} 
            className={`language-dropdown ${i18n.language === "ar" ? 'ar' : 'en'} ${matches ? "desktop" : "mobile"} ${login && "login"}`}
            options={[
                {label: 'En', value: 'en'},
                {label: 'Ar', value: 'ar'},
            ]} 
            onChange={(e) => {
            setLanguage(e.value);
            i18n.changeLanguage(e.value)
            }}/>
            <img src={color === "black" ? EarthBlack : Earth} alt="language switcher" width={20} height={20}/>
        </LnagWrapper>
    )
}

export default LanguageDropDown